import React, { ReactElement } from 'react';

import { DisplayFieldName, DisplayFieldValue } from '../display-form';
import { IIconName } from '../icon';

interface FieldRow {
  icon: ReactElement | IIconName['iconName'];
  label: string;
  value: string;
}

const FieldRow: React.FC<FieldRow> = ({ icon, label, value }) => (
  <>
    <DisplayFieldName iconName={icon}>{label}</DisplayFieldName>
    <DisplayFieldValue label={value} />
  </>
);

export default FieldRow;
